import { render, staticRenderFns } from "./ArtifactSkuInList.vue?vue&type=template&id=490d94fc&scoped=true&"
import script from "./ArtifactSkuInList.vue?vue&type=script&lang=js&"
export * from "./ArtifactSkuInList.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactSkuInList.vue?vue&type=style&index=0&id=490d94fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d94fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VSimpleTable})
